import React from 'react';
import {useSelector} from "react-redux";

function Feature_left(){
    const theme = useSelector(store => store.theme.value)
    return (
        <div className="overflow-hidden py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    <div className="lg:ml-auto lg:pl-4 lg:pt-4">
                        <div className="lg:max-w-lg">
                            <h2 className="text-base font-semibold leading-7 text-chip-bg">Do more</h2>
                            <p className="mt-2 text-3xl font-bold tracking-tight text-text-important sm:text-4xl">Be intentional</p>
                            <p className="mt-6 text-lg leading-8 text-text-bg">
                                We'll help you to think about what you want to achieve and how you can get there.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start justify-end lg:order-first">
                        {theme === "light" &&
                            <img src="planDay_prt_light.png" alt="Planning screenshot" className="w-[37rem] max-w-none rounded-xl shadow-xl ring-1 ring-text-bg/80 sm:w-[37rem]" width={912} height={540} />
                        }
                        {theme === "dark" &&
                            <img src="planDay_prt.png" alt="Planning screenshot" className="w-[37rem] max-w-none rounded-xl shadow-xl ring-1 ring-text-bg/80 sm:w-[37rem]" width={912} height={540} />
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feature_left;
